import * as axios from 'axios';
import { ConfigurationService } from './ConfigurationService';
import { ServiceTypes } from 'utilities/Constants';

export class AxiosServiceFactory {
  private static BaseApiService: axios.AxiosInstance;
  private configService: ConfigurationService;

  constructor(configService: ConfigurationService) {
    this.configService = configService;
  }

  public async createInstance(type: symbol): Promise<axios.AxiosInstance> {
    const baseUrl = this.configService.getWindowOrigin();

    switch (type) {
      case ServiceTypes.apiServiceAxiosInstance:
        return AxiosServiceFactory.BaseApiService || (AxiosServiceFactory.BaseApiService = this.createAxiosInstance(baseUrl, true));

      default:
        throw new Error(`type ${type.toString()} is not found.`);
    }
  }

  private createAxiosInstance(baseUrl: string, withCredentials: boolean): axios.AxiosInstance {
    return axios.default.create({
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      baseURL: baseUrl,
      withCredentials: withCredentials,
    });
  }
}